function isNonEmptyString(value: unknown): boolean {
  return typeof value === 'string' && !!value
}

export type FeatureName = string
export const isFeatureName = isNonEmptyString as (value: unknown) => value is FeatureName

export type VariantName = string
export const isVariantName = isNonEmptyString as (value: unknown) => value is VariantName
export const Original: VariantName = 'Original'

export type VariantKey = string
export const isVariantKey = isNonEmptyString as (value: unknown) => value is VariantKey
